import styled from '@emotion/styled';

export const PageLayout = styled.div`
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 24px;
    padding: 24px;
`;

export const TemplateList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TemplateButton = styled.button`
    text-align: left;
    padding: 8px 12px;
    border: 1px solid #d0d5dd;
    background: #ffffff;
    border-radius: 4px;
    cursor: pointer;

    &[aria-pressed='true'] {
        border-color: #2a78d6;
        background: #eaf2fc;
    }
`;

export const Controls = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;

    & > label {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    & > label > input[type='checkbox'] {
        margin: 0;
    }
`;

export const Notice = styled.div`
    padding: 12px;
    border: 1px solid #f5a524;
    background: #fff8eb;
    border-radius: 4px;
    margin-bottom: 16px;
`;

export const ModeBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    background: #eef1f4;
    font-size: 12px;
`;
